var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.detail.id)?_c('shopMonitor',{attrs:{"dataMsg":_vm.detail,"type-page":"compile"},on:{"getData3":_vm.getData3}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }